import CharacterSheetMobile from './CharacterSheetMobile';

export default CharacterSheetMobile;
export { CharacterSheetMobile };
